module.exports = __webpack_public_path__ + "static/media/disability-small.52fadef1.webp";